import { FontSize } from "../../../assets/font";
import Color from "../../../assets/colors";
import styled, { css } from "styled-components";
import withTheme from "@mui/styles/withTheme";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

// Grid Components //
export const PolicyLanguageContainer = styled(Grid)`
  && {
    max-width: 20%;
    margin: auto;
  }
`;
export const PolicyContainer = styled(Grid)`
  && {
    max-width: 1280px;
    margin: auto;
    padding: 0 5%;
  }
`;

// Typography Components //
export const LabelStyled = styled(Typography)`
  && {
    font-weight: ${FontSize.regular};
    font-size: ${FontSize.desktopBody};
    line-height: 1.5rem;

    ${(props) =>
      props.$version_text &&
      css`
        color: ${Color.hiredlyPurple};
        font-size: ${FontSize.desktopCaption};
        text-align: center;
        cursor: pointer;
        padding: 5px 5px 2px 5px;

        &:hover {
          border-bottom: 2px solid ${Color.hiredlyPurple};
          max-width: 100%;
          margin: auto;
        }
      `}
  }
`;
export const Title = withTheme(styled(Typography)`
  && {
    font-size: ${FontSize.desktopTitle1};
    font-weight: ${FontSize.bold};
    text-align: center;
    margin: 40px 0 0;
  }
`);

// Misc. Components //
export const DividerStyled = styled.div`
  && {
    border-top: 1px solid #d6d6d6;
    width: 30%;
    margin: 30px auto;
  }
`;
